import React, { useContext, useEffect, useState } from "react";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import Box from "@mui/material/Box";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Toast } from "antd-mobile";
import PsContext from "../../context";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { MOB_ICONS, momentDate, upperCase } from "../../utils";
import AttendancePercentage from "../home/attendancePercentage";
import { TABLE_STYLES } from "../../utils/data";
import { Link } from "react-router-dom";
import { listCommunity } from "../../models/fieldSettings";
import moment from "moment";

const AdmissionForm = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [semester, setSemester] = useState();
  const [semesterDates, setSemesterDates] = useState();
  const [feePending, setFeePending] = useState([]);
  const [libraryPending, setLibraryPending] = useState([]);
  const [attendancePercentage, setAttendancePercentage] = useState(0);
  const [applied, setApplied] = useState([]);
  const [minPercentage, setMinPercentage] = useState();
  const [community, setCommunity] = useState([]);
  const [selectCommunity, setSelectCommunity] = useState();
  const [is75, setIs75] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    loadData();
    listCommunity().then((res) => {
      setCommunity(res);
    });
  }, []);

  const UpdateCommunity = () => {
    if (!selectCommunity) {
      Toast.show({ content: "Select Community" });
      return;
    }
    setLoader(true);
    const form = new FormData();
    form.append("uuid", context.user.student_uuid);
    form.append("community", selectCommunity);
    axios
      .post(ServiceUrl.SEMESTER_ADMISSION.UPDATE_COMMUNITY, form)
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Error" });
          context.logout(true);
          context.updateMobileUserId("");
          context.updateMobilePassword("");
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const loadData = () => {
    setLoader(true);
    setSemester([]);
    setFeePending([]);
    setLibraryPending([]);
    const form = new FormData();
    form.append("college_uuid", context.user.college_uuid);
    form.append("student_uuid", context.user.student_uuid);
    form.append("course_uuid", context.user.course_uuid);
    form.append("semester", context.user.current_semester);
    form.append("batch", context.user.batch);
    axios
      .post(ServiceUrl.SEMESTER_ADMISSION.VIEW_PENDINGS, form)
      .then((res) => {
        if (res["data"].status == "1") {
          setSemester(res["data"]?.semester);
          setFeePending(res["data"]?.fee_pending);
          setLibraryPending(res["data"]?.lib_pending);
          setApplied(res["data"]?.applied);
          setIs75(res["data"]?.is_7_5);
          setSemesterDates(res["data"]?.sem_date);
          setMinPercentage(Number(res["data"]?.att_allow_percentage));
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const getSemType = (num) => {
    return num % 2 === 0 ? "even" : "odd";
  };

  const getNextSem = (sem) => {
    const semesterNum = Number(semester);
    const semNum = Number(sem);

    if (!isNaN(semesterNum) && !isNaN(semNum)) {
      if (semesterNum < semNum) {
        return semNum + 1;
      }
    }

    return semNum + 1;
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" + secs : secs}`;
  };

  useEffect(() => {
    const lastClicked = localStorage.getItem("lastClicked");

    if (lastClicked) {
      const currentTime = Date.now();
      const timePassed = currentTime - lastClicked;

      if (timePassed < 600000) {
        setIsDisabled(true);
        const remaining = Math.floor((600000 - timePassed) / 1000);
        setRemainingTime(remaining);
        const timerId = setInterval(() => {
          setRemainingTime((prevTime) => {
            if (prevTime <= 1) {
              clearInterval(timerId);
              setIsDisabled(false);
              localStorage.removeItem("lastClicked");
              return 0;
            }
            return prevTime - 1;
          });
        }, 1000);
        return () => clearInterval(timerId);
      }
    }
  }, []);

  const handleApplyClick = () => {
    const currentTime = Date.now();
    localStorage.setItem("lastClicked", currentTime);
    setIsDisabled(true);
    setRemainingTime(600);
    setTimeout(() => {
      setIsDisabled(false);
      localStorage.removeItem("lastClicked");
    }, 600000);

    const timerId = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerId);
          setIsDisabled(false);
          localStorage.removeItem("lastClicked");
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    ApplyNow();
  };

  const ApplyNow = () => {
    setLoader(true);
    const form = new FormData();
    form.append("academic_year", context.user.college_year);
    form.append("semester_type", getSemType(context.user.current_semester));
    form.append("college_uuid", context.user.college_uuid);
    form.append("student_uuid", context.user.student_uuid);
    form.append("course_uuid", context.user.course_uuid);
    form.append("batch", context.user.batch);
    form.append("admission_no", context.user.admissionno);
    form.append("register_no", context.user.registerno);
    form.append("current_semester", context.user.current_semester);
    form.append("semester_to", getNextSem(context?.user?.current_semester));
    form.append("student_community", context.user.community_name);
    form.append("student_category", "type");
    axios.post(ServiceUrl.SEMESTER_ADMISSION.APPLY_NOW, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({ content: res["data"].message || "Applied" });
        loadData();
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Header title="Admission Form" backAction={true} />
      <div className="page-content-wrapper mb-4">
        {loader && (
          <div className="text-center py-4">
            <Spinner animation="border" role="status" />
          </div>
        )}
        {applied.length < 1 && (
          <div className="container px-0 ">
            <WelcomeProfile />
            <Row className="mb-3">
              {!context.user.community && (
                <Col md={12} className="mb-2 mt-2">
                  <Card>
                    <Card.Header className="card-header-bg text-uppercase fw-bold">
                      <Row>
                        <Col md={8} xs={8} sm={8}>
                          Community
                        </Col>
                        <Col className="text-end" md={4} xs={4} sm={4}>
                          {context.user.community ? (
                            <img
                              src={MOB_ICONS.CHECKMARK_256}
                              style={{ width: "20px" }}
                            />
                          ) : (
                            <img
                              src={MOB_ICONS.PENDING}
                              style={{ width: "20px" }}
                            />
                          )}
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body className="text-center">
                      {!context.user.community && (
                        <Form.Control
                          as="select"
                          name="community"
                          className="fw-bold form-select form-select-sm"
                          onChange={(e) => setSelectCommunity(e.target.value)}
                          size="sm"
                          required
                        >
                          <option value="">-Select-</option>
                          {community.map((item) => (
                            <option value={item.id}>
                              {upperCase(item.community)}
                            </option>
                          ))}
                        </Form.Control>
                      )}

                      <Button
                        className="w-100 mt-2"
                        size="sm"
                        onClick={() => UpdateCommunity()}
                      >
                        UPDATE
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              )}
              {/* <Col md={12} className="mb-2 mt-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    <Row>
                      <Col md={8} xs={8} sm={8}>
                        Library
                      </Col>
                      <Col className="text-end" md={4} xs={4} sm={4}>
                        {libraryPending.length > 0 ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.CHECKMARK_256}
                            style={{ width: "20px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body className="text-center">
                    {libraryPending.length > 0 ? (
                      <span className="text-danger">PENDING</span>
                    ) : (
                      <>
                        <span>NO PENDING</span>
                      </>
                    )}
                  </Card.Body>
                </Card>
              </Col> */}
              <Col md={12} className="mb-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    <Row>
                      <Col md={8} xs={8} sm={8}>
                        Fees
                      </Col>
                      <Col className="text-end" md={4} xs={4} sm={4}>
                        {feePending.length > 0 ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.CHECKMARK_256}
                            style={{ width: "20px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body className="tableFixHead ps-table">
                    {feePending.length > 0 ? (
                      <table width="100%">
                        <tr>
                          <th style={TABLE_STYLES.borderAll}>Category</th>
                          <th style={TABLE_STYLES.borderAll}>Amount</th>
                        </tr>

                        {feePending.map((item) => {
                          return (
                            <tr>
                              <td style={TABLE_STYLES.borderAll}>
                                {item.category_name}
                              </td>
                              <td style={TABLE_STYLES.borderAll}>
                                {parseFloat(item.fee_amount)}
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <th
                            className="text-danger"
                            style={TABLE_STYLES.borderAll}
                          >
                            PENDING
                          </th>
                          <th
                            className="text-danger"
                            style={TABLE_STYLES.borderAll}
                          >
                            {feePending.reduce(
                              (total, item) =>
                                total + parseFloat(item.fee_amount || 0),
                              0,
                            )}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={2}>
                            <center>
                              <Link
                                className="text-center mt-1"
                                to="/stu/app/my-fees"
                              >
                                Click Here to pay now...
                              </Link>
                            </center>
                          </th>
                        </tr>
                      </table>
                    ) : (
                      <>
                        <center>NO PENDING</center>
                      </>
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mb-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    <Row>
                      <Col md={8} xs={8} sm={8}>
                        Attendance
                      </Col>
                      <Col className="text-end" md={4} xs={4} sm={4}>
                        {attendancePercentage < minPercentage ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.CHECKMARK_256}
                            style={{ width: "20px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body className="text-center">
                    <AttendancePercentage
                      show={false}
                      getTotalPercentage={(value) =>
                        setAttendancePercentage(value)
                      }
                    />
                    {/* <h5>{attendancePercentage} %</h5> */}
                    {attendancePercentage < minPercentage ? (
                      <p className="border border-danger p-2 text-danger fw-bold">
                        {/* You are on the re-do list, so you are not eligible to
                        apply */}
                        NOT ELIGIBLE
                      </p>
                    ) : (
                      <p className="border border-success p-2 text-success fw-bold">
                        ELIGIBLE
                      </p>
                    )}
                  </Card.Body>
                </Card>
              </Col>

              <Col md={12} className="mb-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    Apply Now
                  </Card.Header>
                  <Card.Body className="text-center">
                    {semesterDates?.end_date &&
                    new Date() > new Date(semesterDates.end_date) &&
                    semesterDates?.end_date != null ? (
                      <>
                        <Form.Check
                          type="checkbox"
                          size="lg"
                          name="is_dalit"
                          // libraryPending.length > 0 ||
                          disabled={
                            feePending.length > 0 ||
                            attendancePercentage < minPercentage ||
                            !context.user.community ||
                            semester <= context.user?.current_semester
                          }
                          onChange={(e) => setIsConfirmed(e.target.checked)}
                          required
                          label="I acknowledge that I am accept to terms and conditions to promote next semester."
                        />
                        {isConfirmed && (
                          <Button
                            fille="outline"
                            block
                            size="sm"
                            className="mt-2"
                            // onClick={() => ApplyNow()}
                            disabled={isDisabled}
                            onClick={handleApplyClick}
                          >
                            {isDisabled
                              ? `Wait For ${formatTime(remainingTime)}`
                              : " Apply Now"}
                          </Button>
                        )}
                      </>
                    ) : (
                      "The Admission Form Apply Date has not been updated yet. Please check back later."
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )}
        {applied && applied.length > 0 && (
          <div className="container px-0 ">
            <WelcomeProfile />
            <Row>
              <Col md={12} className="mt-2">
                {applied[0].is_promotted == "1" && (
                  <Card className="border p-1 fw-bold text-center">
                    You have Promoted For next Semester Please Logout and Login
                    Again to Continue
                  </Card>
                )}
              </Col>
              <Col md={12} className="mt-2">
                {applied[0].no_fees == "1"
                  ? applied[0].prof_noc == "1" &&
                    applied[0].library_noc == "1" &&
                    applied[0].is_verified == "1" &&
                    applied[0].is_promotted == "1" &&
                    applied[0].is_completed == "0" && (
                      <Card className="border p-1 fw-bold text-center text-danger">
                        Please contact the office for attendance approval
                      </Card>
                    )
                  : applied[0].prof_noc == "1" &&
                    applied[0].library_noc == "1" &&
                    applied[0].is_verified == "1" &&
                    applied[0].is_promotted == "1" &&
                    applied[0].is_fees_paid == "1" &&
                    applied[0].is_completed == "0" && (
                      <Card className="border p-1 fw-bold text-center text-danger">
                        Please contact the office for attendance approval
                      </Card>
                    )}
              </Col>
              <Col md={12} className="mt-2">
                {applied[0].no_fees == "0" &&
                  applied[0].is_fees_paid == "0" &&
                  applied[0].prof_noc == "1" &&
                  applied[0].library_noc == "1" &&
                  applied[0].is_verified == "1" &&
                  applied[0].is_promotted == "1" && (
                    <Card className="border p-1 fw-bold text-center text-danger">
                      Fees Pending{" "}
                      <Link className="text-center mt-1" to="/stu/app/my-fees">
                        Click Here to pay now...
                      </Link>
                    </Card>
                  )}
              </Col>
              <Col md={12} className="mt-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    Admission Officer
                  </Card.Header>

                  <Card.Body>
                    <Row>
                      <Col md={9} sm={9} xs={9}>
                        <table width="100%">
                          <tr>
                            <th>Status</th>
                            <td>:</td>
                            <td>
                              {applied[0].prof_noc == "0"
                                ? "PENDING"
                                : "APPROVED"}
                            </td>
                          </tr>
                          {applied[0].prof_noc == "0" && (
                            <tr>
                              <th>Reason</th>
                              <td>:</td>
                              <td>{applied[0].prof_noc_reason}</td>
                            </tr>
                          )}
                          <tr>
                            <th width="40%">Approved On</th>
                            <td width="2%">:</td>
                            <td width="58%">
                              {momentDate(
                                applied[0].prof_noc_issued_on,
                                "DD-MM-YYYY",
                              )}{" "}
                              {momentDate(
                                applied[0].prof_noc_issued_on,
                                "hh:mm A",
                              )}
                            </td>
                          </tr>
                        </table>
                      </Col>
                      <Col md={3} sm={3} xs={3}>
                        {applied[0].prof_noc == "0" ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "60px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.APPROVED}
                            style={{ width: "100px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mt-2">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    Library Officer
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={9} sm={9} xs={9}>
                        <table width="100%">
                          <tr>
                            <th>Status</th>
                            <td>:</td>
                            <td>
                              {applied[0].library_noc == "0"
                                ? "PENDING"
                                : "APPROVED"}
                            </td>
                          </tr>
                          {applied[0].library_noc == "0" && (
                            <tr>
                              <th>Reason</th>
                              <td>:</td>
                              <td>{applied[0].library_noc_reason}</td>
                            </tr>
                          )}
                          <tr>
                            <th width="40%">Approved On</th>
                            <td width="2%">:</td>
                            <td width="58%">
                              {momentDate(
                                applied[0].library_noc_issued_on,
                                "DD-MM-YYYY",
                              )}
                              {momentDate(
                                applied[0].library_noc_issued_on,
                                "hh:mm A",
                              )}
                            </td>
                          </tr>
                        </table>
                      </Col>
                      <Col md={3} sm={3} xs={3}>
                        {applied[0].library_noc == "0" ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "60px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.APPROVED}
                            style={{ width: "100px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mt-2 mb-3">
                <Card>
                  <Card.Header className="card-header-bg text-uppercase fw-bold">
                    Office Approval
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={9} sm={9} xs={9}>
                        <table width="100%">
                          <tr>
                            <th>Status</th>
                            <td>:</td>
                            <td>
                              {applied[0].is_verified == "0"
                                ? "PENDING"
                                : "APPROVED"}
                            </td>
                          </tr>
                          <tr>
                            <th width="40%">Approved On</th>
                            <td width="2%">:</td>
                            <td width="58%">
                              {momentDate(applied[0].verified_on, "DD-MM-YYYY")}{" "}
                              {momentDate(applied[0].verified_on, "hh:mm A")}
                            </td>
                          </tr>
                          <tr>
                            <th width="40%">Promoted</th>
                            <td width="2%">:</td>
                            <td width="58%">
                              {applied[0].is_promotted == "1" ? "YES" : "NO"}
                            </td>
                          </tr>
                          <tr>
                            <th width="40%">Fees</th>
                            <td width="2%">:</td>
                            <td width="58%">
                              {applied[0].fees_generated == "1"
                                ? "ASSIGNED"
                                : "NOT ASSIGNED"}
                            </td>
                          </tr>
                        </table>
                      </Col>
                      <Col md={3} sm={3} xs={3}>
                        {applied[0].is_verified == "0" ? (
                          <img
                            src={MOB_ICONS.PENDING}
                            style={{ width: "60px" }}
                          />
                        ) : (
                          <img
                            src={MOB_ICONS.APPROVED}
                            style={{ width: "100px" }}
                          />
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </div>
    </>
  );
};

export default AdmissionForm;
